const isResolvedResource = require('../contentful/is-resolved-resource');
const isResolvedCollection = require('../contentful/is-resolved-collection');
const makeTransformer = require('./make');
const dealerTransformer = require('./dealer');
const articleTransformer = require('./article');
const modelTransformer = require('./model');
const campaignTransformer = require('./campaign');
const assetTransformer = require('./asset');

const createAssetLink = (asset) => {
  return {
    sys: {
      type: 'Link',
      linkType: 'Asset',
      id: asset.id
    }
  };
};

const createEntryLink = (entry) => {
  return {
    sys: {
      type: 'Link',
      linkType: 'Entry',
      id: entry.id
    }
  };
};

module.exports = {
  contentfulToInternal(entry) {
    // console.log('entry', entry);
    const result = {
      id: entry.sys.id,
      published: Boolean(entry.sys.publishedVersion),
      updated: entry.sys.publishedVersion && entry.sys.version > entry.sys.publishedVersion + 1,
      draft: !entry.sys.publishedVersion,
      archived: Boolean(entry.sys.archivedVersion),
      contentType: null,
      created: new Date(entry.sys.createdAt),

      name: (entry.fields.name ? entry.fields.name['nb-NO'] : null),
      url: (entry.fields.url ? entry.fields.url['nb-NO'] : null),
      priority: (entry.fields.priority ? entry.fields.priority['nb-NO'] : 0),
      metadata: (entry.fields.metadata ? entry.fields.metadata['nb-NO'] : {}),

      motorforumOnly: (entry.fields.motorforumOnly ? entry.fields.motorforumOnly['nb-NO'] : false),
      mode: (entry.fields.mode ? entry.fields.mode['nb-NO'] : null),

      dealerIds: [],
      dealers: [],
      make: null,
      makeId: entry.fields.make && entry.fields.make['nb-NO'].sys.id,
      target: null,
      targetType: null,
      image: null,

      // Available modes, extracted from the contenttype
      modes: []
    };

    if (entry.sys && entry.sys.contentType) {
      result.contentType = entry.sys.contentType.sys.id;


      if (entry.sys.contentType.fields) {
        const modes = entry.sys.contentType.fields.find((field) => {
          return field.id === 'mode';
        });
        if (modes) {
          result.modes = modes.validations[0].in;
        }
      }
    }

    result.dealerIds = entry.fields.dealers ? entry.fields.dealers['nb-NO'].map((d) => d.sys.id) : [];
    if (entry.fields.dealers && entry.fields.dealers['nb-NO'] && isResolvedCollection(entry.fields.dealers['nb-NO'])) {
      result.dealers = entry.fields.dealers['nb-NO'].map(dealerTransformer.contentfulToInternal);
    }

    if (entry.fields.make && entry.fields.make['nb-NO'] && isResolvedResource(entry.fields.make['nb-NO'])) {
      result.make = makeTransformer.contentfulToInternal(entry.fields.make['nb-NO']);
    }

    if (entry.fields.image && entry.fields.image['nb-NO'] && isResolvedResource(entry.fields.image['nb-NO'])) {
      result.image = assetTransformer.contentfulToInternal(entry.fields.image['nb-NO']);
    }

    if (entry.fields.target) {
      result.targetId = entry.fields.target['nb-NO'].sys.id;

      if (isResolvedResource(entry.fields.target)) {
        if (entry.fields.target['nb-NO'].sys.contentType) {
          result.targetType = entry.fields.target['nb-NO'].sys.contentType.sys.id;

          switch (result.targetType) {
            case 'articlecollection':
              result.target = articleTransformer.contentfulToInternal(entry.fields.target['nb-NO']);
              break;
            case 'model':
              result.target = modelTransformer.contentfulToInternal(entry.fields.target['nb-NO']);
              break;
            case 'campaign':
              result.target = campaignTransformer.contentfulToInternal(entry.fields.target['nb-NO']);
              break;
          }
        }
      }
    }

    return result;
  },

  internalToContentful(og) {
    const result = {
      fields: {
        name: {
          'nb-NO': og.name
        },
        url: {
          'nb-NO': og.url || null
        },
        priority: {
          'nb-NO': og.priority ? parseInt(og.priority, 10) : null
        },
        metadata: {
          'nb-NO': og.metadata || null
        },
        mode: {
          'nb-NO': og.mode || null
        },

        image: null,
        target: null,
        make: null
      }
    };

    if (og.target) {
      result.fields.target = {
        'nb-NO': createEntryLink(og.target)
      };
    }

    if (og.make) {
      result.fields.make = {
        'nb-NO': createEntryLink(og.make)
      };
    }

    if (og.image) {
      result.fields.image = {
        'nb-NO': createAssetLink(og.image)
      };
    }

    if (og.dealers) {
      result.fields.dealers = {
        'nb-NO': og.dealers ? og.dealers.map(createEntryLink) : null
      };
    }

    return result;
  }
};
